import * as id from 'lib/id'
import type { NextFn } from 'types/adapters'

interface IdentifiedAction {
  id?: string
  [key: string]: unknown
}

export default () => (next: NextFn<IdentifiedAction>) => (action: IdentifiedAction) => {
  action.id ??= id.createId()
  return next(action)
}
